<template>
  <div class="container">
    <q-page padding>
      <div class="row col-12">
        <p class="text-h6 text-brand-5 text-weight-bold">
          Transferências de Ferramentas
        </p>
      </div>

      <div class="row q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
        <div class="col-sm-1 col-4">
          <select-unidades :titulo="'Origem'" @emitirUnidade="filtrarOrigem" />
        </div>
        <div class="col-md-1 col-4">
          <select-unidades
            :titulo="'Destino'"
            @emitirUnidade="filtrarDestino"
          />
        </div>
        <div class="col-md-1 col-4">
          Status
          <q-select
            :options="statusOptions"
            dense
            outlined
            v-model="filtros.status"
          />
        </div>
        <div class="col-md-1">
          Número
          <q-input
            dense
            outlined
            v-model="filtros.numero"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />
        </div>
        <div class="col-md-1">
          Patrimonio
          <q-input dense outlined v-model="filtros.patrimonio" />
        </div>

        <div class="col-md-2">
          Data Inicial
          <q-input
            mask="##/##/####"
            dense
            outlined
            v-model="filtros.dataInicial"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataInicial"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <p class="row text-inputs-line q-ml-sm q-mt-lg text-bold">Até</p>
        <div class="col-md-2 q-ml-sm">
          Data Final
          <q-input mask="##/##/####" dense outlined v-model="filtros.dataFinal">
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataFinal"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2">
          <p></p>
          <q-btn
            color="primary"
            icon="filter_alt"
            no-caps
            label="Filtrar"
            class="q-mt-sm"
            @click="filtrarTabela"
          />
        </div>
      </div>
      <div class="q-my-xl">
        <p></p>
        <q-btn
          label="Criar Transferência"
          @click="rightDrawerOpen = true"
          color="primary"
          no-caps
          :outline="!rightDrawerOpen"
          icon="add"
        />
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="q-pa-md text-weight-bold" style="height: 92%">
            <div class="row col-12 justify-between items-center">
              <div class="col-md-12 items-center">
                <q-icon
                  style="cursor: pointer; margin-bottom: 1px"
                  name="close"
                  class="q-mr-xs"
                  size="19px"
                  @click="rightDrawerOpen = false"
                />
                <span style="font-size: 16px">
                  <span> Transferir Ferramentas </span>
                </span>
              </div>
            </div>
            <div
              class="column justify-between"
              style="height: 100%; width: 100%"
            >
              <div>
                <div class="col-md-12 q-mt-md">
                  <div class="q-mb-xs">Origem</div>
                  <select-unidades @emitirUnidade="receberDadosUnidadeOrigem" />
                </div>
                <div class="col-md-12 q-mt-sm">
                  <div class="q-mb-xs">Destino</div>
                  <select-unidades
                    @emitirUnidade="receberDadosUnidadeDestino"
                  />
                </div>
                <div class="col-md-12 q-mt-sm">
                  <div class="q-mb-xs">Operação</div>
                  <q-select
                    :options="operacao"
                    dense
                    outlined
                    v-model="almox"
                  />
                </div>
                <div class="col-md-12 q-mt-sm">
                  <div class="q-mb-xs">Nº Doc</div>
                  <q-input dense outlined v-model="numeroPedido" />
                </div>
              </div>
              <div class="row">
                <div class="row col-12 justify-end">
                  <q-btn
                    icon="add_circle_outline"
                    color="positive"
                    label="Criar Transferência"
                    dense
                    no-caps
                    @click="criarTransferencia"
                  />
                </div>
              </div>
            </div>
          </div>
        </q-card>
      </Transition>
      <div class="row col-12 q-mt-xl q-ml-md">
        <p class="text-h6 self-end text-brand-5 text-weight-bold">
          Movimentações
        </p>
      </div>

      <transferencias-criadas :filtros="filtros" :atualizar="atualizar" />
    </q-page>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import SelectUnidades from "../components/SelectUnidades.vue";
import TransferenciasCriadas from "../components/TransferenciasCriadas.vue";

export default {
  name: "trasnferenciaFerramentas",
  components: { SelectUnidades, TransferenciasCriadas },
  setup() {
    const $q = useQuasar();
    const numeroPedido = ref("");
    const atualizar = ref([]);
    const router = useRouter();
    const filtros = ref({
      status: "",
      dataInicial: "",
      dataFinal: "",
      origem: "",
      destino: "",
      numero: "",
      patrimonio: "",
    });
    const almox = ref("");
    const status = ref("");
    const origem = ref("");
    const destino = ref("");
    let rightDrawerOpen = ref(false);

    const store = useStore();

    const criarTransferencia = async () => {
      if (origem.value == "" || destino.value == "" || almox.value == "") {
        $q.notify({
          message: "Preencha todos os campos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        let response = await store.dispatch("fer/criarTransferencia", {
          unidade_origem_id: origem.value,
          unidade_destino_id: destino.value,
          almox: almox.value,
          pedido: numeroPedido.value,
        });

        $q.notify({
          message: "Transferencia criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        rightDrawerOpen.value = false;
        router.push({
          name: "detalheTransferencia",
          params: { id: response.data.uuid },
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao criar transferencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    let receberDadosUnidadeOrigem = async (value) => {
      origem.value = value.value.id;
    };
    let receberDadosUnidadeDestino = async (value) => {
      destino.value = value.value.id;
    };

    let filtrarOrigem = async (value) => {
      filtros.value.origem = value.value.id;
    };

    let filtrarDestino = async (value) => {
      filtros.value.destino = value.value.id;
    };

    const filtrarTabela = async () => {
      atualizar.value.push("1");
    };

    return {
      options: ["Operacional", "Manutenção", "Produção", "Estoque"],
      receberDadosUnidadeOrigem,
      filtrarOrigem,
      filtrarDestino,
      almox,
      receberDadosUnidadeDestino,
      numeroPedido,
      origem,
      destino,
      status,
      filtros,
      filtrarTabela,
      atualizar,
      statusOptions: [
        "criada",
        "enviada",
        "cancelada",
        "recebida",
        "recebida_parcialmente",
        "rejeitada",
        "deletada",
      ],
      operacao: [
        "Manutenção",
        "Desmobilização",
        "Transição entre pontos",
        "Retorno de Manutenção",
        "Locação",
        "Material Próprio",
      ],
      criarTransferencia,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      rightDrawerOpen,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.align {
  align-items: center;
}
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  top: 106px;
  height: calc(100% - 10px);
  position: fixed;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.text-inputs-line {
  margin-top: 37px;
}
</style>
